var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-logo"},[_c('transition',{attrs:{"name":"slide-fade","mode":"in-out"}},[_c('div',{key:this.projectLogo,staticClass:"project-logo",style:(_vm.resolveStyle())},[_c('img',{attrs:{"src":this.projectLogo}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }